import { c as _c } from "react/compiler-runtime";
import classNames from 'classnames';
import { TextLink } from '../../components/TextLink';
import type { ImageProps, LinkItemData, LinkProps } from './types';
export function DefaultLink(t0) {
  const $ = _c(4);
  let props;
  if ($[0] !== t0) {
    const {
      prefetch: _,
      external: __,
      ...t1
    } = t0;
    props = t1;
    $[0] = t0;
    $[1] = props;
  } else {
    props = $[1];
  }
  let t1;
  if ($[2] !== props) {
    t1 = <TextLink {...props} />;
    $[2] = props;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}
export function DefaultImage(props) {
  const $ = _c(2);
  let t0;
  if ($[0] !== props) {
    t0 = <img {...props} />;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}
export type LinkItemProps = LinkItemData & {
  'Link': React.FC<LinkProps>;
  'onClick'?: (event: React.MouseEvent<HTMLAnchorElement>) => void;
  'title'?: string;
  'doNotOpenInNewTab'?: boolean;
  'data-axe-expect'?: string;
};
export function LinkItem(t0) {
  const $ = _c(15);
  const {
    Link,
    href,
    hidden,
    children,
    external,
    className,
    onClick,
    prefetch,
    title,
    doNotOpenInNewTab,
    "data-axe-expect": dataAxeExpect
  } = t0;
  let t1;
  if ($[0] !== className || $[1] !== hidden) {
    t1 = classNames(className, {
      "hide-link": hidden
    });
    $[0] = className;
    $[1] = hidden;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const t2 = external ? "noopener noreferrer" : undefined;
  const t3 = doNotOpenInNewTab || !external ? undefined : "_blank";
  let t4;
  if ($[3] !== Link || $[4] !== children || $[5] !== dataAxeExpect || $[6] !== external || $[7] !== href || $[8] !== onClick || $[9] !== prefetch || $[10] !== t1 || $[11] !== t2 || $[12] !== t3 || $[13] !== title) {
    t4 = <Link href={href} onClick={onClick} title={title} aria-label={title} prefetch={prefetch} external={external} className={t1} rel={t2} target={t3} data-axe-expect={dataAxeExpect}>{children}</Link>;
    $[3] = Link;
    $[4] = children;
    $[5] = dataAxeExpect;
    $[6] = external;
    $[7] = href;
    $[8] = onClick;
    $[9] = prefetch;
    $[10] = t1;
    $[11] = t2;
    $[12] = t3;
    $[13] = title;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  return t4;
}